import { VisualizationTypeOption } from './widgetModels';

export const ComponentType = {
  FILTER: 'filter',
  WIDGET: 'widget',
  DASHLET: 'dashlet',
} as const;
export type ComponentTypeOption = (typeof ComponentType)[keyof typeof ComponentType];

export type PropsMap = Partial<Record<VisualizationTypeOption, Record<string, any>>>;
